<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <SqlQuery
          database="fishbowl"
          :query="query"
          show-csv
          readonly
          autorun
          run-text="Run Query"
          class="m-4"
          v-if="!loading"
        />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import SqlQuery from '../utility/SqlQuery';
import axios from 'axios'
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    SqlQuery,
  },
  data() {
    return {
      query: undefined,
      loading: true
    }
  },
  mounted() {
    axios.get(`${BASE_API}/fishbowl/reports/inventory-costing/query`).then(response => {
      this.query = response.data
      this.loading = false
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventory/CostingReport.vue